import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { GlobalService } from '../../../services/global.service';

@Component({
	selector: 		'notes-popup',
	templateUrl:  './notes-history.html',
	styleUrls: 		['./notes-history.css']
})
export class NotesHistory implements OnInit {

	constructor ( public global: GlobalService ) { }

	@Input( )
	notesList: 		Array<any>	= [];
	popupVisible: boolean 		= false;

	ngOnInit ( ) { }

	closePopup ( ) { this.global.changeHPVisibility( false ); }

}


// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/notes-history/notes-history.ts